import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "card shadow-sm" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row mb-6" }
const _hoisted_7 = { class: "col-lg-4 mb-5 d-flex flex-column align-items-center justify-content-center" }
const _hoisted_8 = {
  class: "image-input image-input-outline w-125px h-125px",
  style: {"position":"relative"}
}
const _hoisted_9 = {
  class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow",
  for: "avatarInput",
  title: "Change avatar",
  style: {"position":"absolute","top":"0","right":"0","transform":"translate(30%, -30%)"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "avatar_remove"
}, null, -1)
const _hoisted_12 = { class: "form-text" }
const _hoisted_13 = { class: "col-lg-8" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6 mb-5" }
const _hoisted_16 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_17 = { class: "col-lg-4 mb-5" }
const _hoisted_18 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_19 = { class: "col-lg-4 mb-5" }
const _hoisted_20 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_21 = { class: "col-lg-4 mb-5" }
const _hoisted_22 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_23 = { class: "col-lg-6 mb-5" }
const _hoisted_24 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_25 = {
  key: 0,
  class: "col-lg-6 mb-5"
}
const _hoisted_26 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_27 = { class: "col-lg-6 mb-5" }
const _hoisted_28 = {
  for: "",
  class: "required mb-3"
}
const _hoisted_29 = { class: "col-lg-6 mb-5" }
const _hoisted_30 = { class: "d-flex gap-5 flex-end mt-10" }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border h-15px w-15px align-middle text-gray-400" }, null, -1)
const _hoisted_34 = { class: "mb-10" }
const _hoisted_35 = { class: "card shadow-sm" }
const _hoisted_36 = { class: "card-header" }
const _hoisted_37 = { class: "card-title" }
const _hoisted_38 = { class: "card-body" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-lg-6 mb-4" }
const _hoisted_41 = { class: "form-label mb-2" }
const _hoisted_42 = { class: "d-flex align-items-center gap-4" }
const _hoisted_43 = { class: "col-lg-6 mb-4" }
const _hoisted_44 = { class: "form-label mb-2" }
const _hoisted_45 = { class: "d-flex align-items-center gap-4" }
const _hoisted_46 = { class: "mb-10" }

import AuthImage from "@/components/AuthImage.vue";
import { getRegionCodes } from "@/core/data/phonesData";
import GlobalService from "@/projects/client/services/ClientGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Actions } from "@/store/enums/StoreEnums";
import { ref, watch, onMounted } from "vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { EditPen } from "@element-plus/icons-vue";
import { useI18n } from "vue-i18n";
import { isMobile } from "@/core/config/WindowConfig";
import PasswordSetting from "./PasswordSetting.vue";
import LoginDeviceManagement from "./components/LoginDeviceManagement.vue";
import UnifiedTwoFaVerificationModal from "@/components/modal/UnifiedTwoFaVerificationModal.vue";
import { AuthEventTypes } from "@/core/types/AuthEventTypes";
import ApiService from "@/core/services/ApiService";

type VerificationMethod = "email" | "sms" | "authenticator";

// <el-icon><EditPen /></el-icon>

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSetting',
  setup(__props) {

const store = useStore();
const user = store.state.AuthModule.user;
const router = useRouter();
const isLoading = ref(false);
const regionCodes = ref(getRegionCodes());
const { t } = useI18n();
const showOtp = ref(false);

// 2FA状态：通过API获取，而不是从user对象
const authenticatorEnabled = ref(false);
const emailEnabled = ref(false);

// 从API获取可用的认证类型，判断哪些验证方式已启用
const fetchTwoFactorStatus = async () => {
  try {
    // 确保设置了认证header
    ApiService.setHeader();
    const response = await ApiService.get(
      "/api/v2/auth/auth-code/available-auth-types"
    );
    const authTypes: string[] = response.data || [];
    authenticatorEnabled.value = authTypes.includes("authenticator");
    emailEnabled.value = authTypes.includes("email");
  } catch (error) {
    console.error("Failed to fetch 2FA status:", error);
    authenticatorEnabled.value = false;
    emailEnabled.value = false;
  }
};

// 组件挂载时获取2FA状态
onMounted(() => {
  fetchTwoFactorStatus();
});

const initialCollectData = {
  firstName: user.firstName,
  lastName: user.lastName,
  nativeName: user.nativeName,
  ccc: parseInt(user.ccc),
  phoneNumber: user.phoneNumber,
  email: user.email,
  countryCode: user.countryCode.toLowerCase(),
  language: user.language,
  currencyId: user.currencyId,
  timezone: user.timezone,
};

const deepCopy = JSON.parse(JSON.stringify(initialCollectData));
const collectData = ref<any>(deepCopy);

const resetData = () => {
  collectData.value = JSON.parse(JSON.stringify(initialCollectData));
};

const avatarUpload = async (event: any) => {
  if (event.target.files.item(0) == null) return;

  const file = event.target.files.item(0);
  const reader = new FileReader();
  reader.readAsDataURL(file);

  const form = new FormData();
  form.append("avatar", file);
  isLoading.value = true;

  try {
    const res = await GlobalService.uploadUserAvatar(form);
    await store.dispatch(Actions.SET_AVATAR, res.url);
    isLoading.value = false;
    // MsgPrompt.success();
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const twoFaModalRef = ref<any>();
const is2FaSetupMode = ref(false);
const currentMethod = ref<"authenticator" | "email">("authenticator");

const onAuthenticatorEnabledChanged = async (value: boolean) => {
  currentMethod.value = "authenticator";
  if (value) {
    // 用户想要开启2FA：直接进入Authenticator的setup流程
    // 注意：不要改变 collectData.twoFactorEnabled，保持为 false
    // 只有验证成功后才设置为 true
    is2FaSetupMode.value = true;
    // availableMethods: ["authenticator"] - 只支持这一种方式
    // authTypes: [] - 空数组表示用户当前未启用任何2FA，触发setup模式
    twoFaModalRef.value?.show(
      ["authenticator"], // 只显示Authenticator
      user.email,
      [] // 空数组，直接进入setup模式
    );
  } else {
    // 用户想要关闭2FA：需要验证码
    // 注意：不要改变 collectData.twoFactorEnabled，保持为 true
    // 只有验证成功后才设置为 false
    is2FaSetupMode.value = false;
    twoFaModalRef.value?.show(
      ["authenticator"],
      user.email,
      ["authenticator"] // 已启用，需要验证
    );
  }
};

const onEmailEnabledChanged = async (value: boolean) => {
  currentMethod.value = "email";
  if (value) {
    // 用户想要开启Email验证：需要验证码
    is2FaSetupMode.value = true;
    twoFaModalRef.value?.show(
      ["email"], // 只显示Email
      user.email,
      ["email"], // 已启用，需要验证
      undefined,
      AuthEventTypes.TenantEmailTwoFactorEnable
    );
  } else {
    // 用户想要关闭Email验证：需要验证码
    is2FaSetupMode.value = false;
    twoFaModalRef.value?.show(
      ["email"],
      user.email,
      ["email"], // 已启用，需要验证
      undefined,
      AuthEventTypes.TenantEmailTwoFactorDisable
    );
  }
};

// 2FA验证成功回调
const onTwoFaVerified = async (code: string, method: VerificationMethod) => {
  try {
    if (currentMethod.value === "authenticator") {
      if (is2FaSetupMode.value) {
        // Setup模式：UnifiedTwoFaVerificationModal中已经调用了enable API
        // 重新获取2FA状态
        await fetchTwoFactorStatus();

        if (authenticatorEnabled.value) {
          MsgPrompt.success(t("tip.authenticatorEnabledSuccess"));
        } else {
          // 如果状态还是false，说明enable失败了
          MsgPrompt.error(t("tip.authenticatorEnabledFailed"));
        }
      } else {
        // 关闭Authenticator：调用disable API
        await ApiService.put("/api/v2/auth/auth-code/authenticator/disable", {
          code: code,
        });
        // 重新获取2FA状态
        await fetchTwoFactorStatus();

        if (!authenticatorEnabled.value) {
          MsgPrompt.success(t("tip.authenticatorDisabledSuccess"));
          if (!emailEnabled.value) {
            await store.dispatch(Actions.LOGOUT);
            await router.push({ name: "sign-in" });
            return;
          }
        } else {
          // 如果状态还是true，说明disable失败了
          MsgPrompt.error(t("tip.authenticatorDisabledFailed"));
        }
      }
    } else if (currentMethod.value === "email") {
      if (is2FaSetupMode.value) {
        // 开启Email验证：调用enable API
        await ApiService.put("/api/v2/auth/auth-code/email/enable", {
          email: user.email,
          code: code,
        });
        // 重新获取2FA状态
        await fetchTwoFactorStatus();

        if (emailEnabled.value) {
          MsgPrompt.success(t("tip.emailVerificationEnabledSuccess"));
        } else {
          MsgPrompt.error("Failed to enable Email verification");
        }
      } else {
        // 关闭Email验证：调用disable API
        await ApiService.put("/api/v2/auth/auth-code/email/disable", {
          code: code,
        });
        // 重新获取2FA状态
        await fetchTwoFactorStatus();

        if (!emailEnabled.value) {
          MsgPrompt.success(t("tip.emailVerificationDisabledSuccess"));
          if (!authenticatorEnabled.value) {
            await store.dispatch(Actions.LOGOUT);
            await router.push({ name: "sign-in" });
            return;
          }
        } else {
          MsgPrompt.error("Failed to disable Email verification");
        }
      }
    }
    // 更新store中的用户信息（可能其他地方需要用到）
    await store.dispatch(Actions.VERIFY_AUTH);
    twoFaModalRef.value?.closeModal();
  } catch (error: any) {
    // 显示内联错误，不弹窗
    twoFaModalRef.value?.showError(t("tip.invalidCodePleaseTryAgain"));
  }
}; // 2FA验证取消回调
const onTwoFaCancel = () => {
  // 用户取消了操作，不需要做任何事情
  // authenticatorEnabled 和 emailEnabled 状态保持不变，开关会自动保持原状态
};

// const discard = () => {
//   regionCode.value = originalPhoneData.value.regionCode;
//   collectData.value.ccc = originalPhoneData.value.ccc;
//   collectData.value.phoneNumber = originalPhoneData.value.phoneNumber;
//   collectData.value.otp = "";
// };

// const sendOtpCode = async () => {
//   //
//   try {
//     await GlobalService.sendVerificationOneTimeCodeForPhone(
//       collectData.value.ccc,
//       collectData.value.phoneNumber
//     );
//     MsgPrompt.success(
//       t("tip.verificationCodeSendTo") +
//         " +" +
//         collectData.value.ccc +
//         " " +
//         collectData.value.phoneNumber
//     );
//     smsInterval.value = 60;
//     const interval = setInterval(() => {
//       smsInterval.value--;
//       if (smsInterval.value <= 0) clearInterval(interval);
//     }, 1000);
//   } catch (error) {
//     MsgPrompt.error(error);
//   }
// };

watch(
  [() => collectData.value.ccc, () => collectData.value.phoneNumber],
  () => {
    showOtp.value =
      collectData.value.ccc != user.ccc ||
      collectData.value.phoneNumber != user.phoneNumber;
  }
);

const submit = async () => {
  //
  isLoading.value = true;
  try {
    if (showOtp.value) {
      // if (!collectData.value.otp || collectData.value.otp === "") {
      //   MsgPrompt.error(t("tip.oneTimeCodeVerificationFail"));
      //   return;
      // }
      await GlobalService.verifyPhoneNumberChange(
        collectData.value.ccc,
        collectData.value.phoneNumber,
        "undefined"
      );
      MsgPrompt.success(t("tip.profileUpdated"));
      collectData.value.otp = "";
      showOtp.value = false;
    } else {
      MsgPrompt.warning(t("tip.nothingToUpdate"));
    }
    // if (
    //   collectData.value.firstName === user.firstName &&
    //   collectData.value.lastName === user.lastName
    // ) {
    //   MsgPrompt.error(t("tip.nothingToUpdate"));
    //   return;
    // }
    // await GlobalService.updateUserProfile({
    //   firstName: collectData.value.firstName,
    //   lastName: collectData.value.lastName,
    // });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("title.basicInfo")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass({ 'pe-10': !_unref(isMobile) })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(AuthImage, {
                    imageGuid: _unref(user).avatar,
                    alt: _unref(user).name,
                    side: "client",
                    class: "image-input-wrapper w-125px h-125px"
                  }, null, 8, ["imageGuid", "alt"]),
                  _createElementVNode("label", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("input", {
                      class: "d-none",
                      id: "avatarInput",
                      type: "file",
                      name: "avatar",
                      accept: ".png, .jpg, .jpeg, .heic",
                      onChange: avatarUpload
                    }, null, 32),
                    _hoisted_11
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("tip.allowedFileTypes")) + ": png, jpg, jpeg. ", 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("title.email")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: collectData.value.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((collectData.value.email) = $event)),
                      size: "large",
                      disabled: "",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("fields.nativeName")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: collectData.value.nativeName,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((collectData.value.nativeName) = $event)),
                      size: "large",
                      clearable: "",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("fields.firstName")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: collectData.value.firstName,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((collectData.value.firstName) = $event)),
                      size: "large",
                      clearable: "",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("fields.lastName")), 1),
                    _createVNode(_component_el_input, {
                      modelValue: collectData.value.lastName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((collectData.value.lastName) = $event)),
                      size: "large",
                      clearable: "",
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("fields.countryAndRegion")), 1),
                    _createVNode(_component_el_select, {
                      modelValue: collectData.value.countryCode,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((collectData.value.countryCode) = $event)),
                      size: "large",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.code,
                            value: item.code,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
                        _createVNode(_component_el_input, {
                          modelValue: collectData.value.phoneNumber,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((collectData.value.phoneNumber) = $event)),
                          size: "large",
                          "suffix-icon": _unref(EditPen)
                        }, {
                          prepend: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: collectData.value.ccc,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((collectData.value.ccc) = $event)),
                              size: "large",
                              style: {"width":"190px"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.code,
                                    value: item.dialCode,
                                    label: item.name + ' + ' + item.dialCode
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "suffix-icon"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isMobile))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("fields.phoneNum")), 1),
                          _createVNode(_component_el_select, {
                            size: "large",
                            modelValue: collectData.value.ccc,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((collectData.value.ccc) = $event))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regionCodes.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.code,
                                  value: item.dialCode,
                                  label: item.name + ' + ' + item.dialCode
                                }, null, 8, ["value", "label"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_el_input, {
                            modelValue: collectData.value.phoneNumber,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((collectData.value.phoneNumber) = $event)),
                            size: "large",
                            "suffix-icon": _unref(EditPen)
                          }, null, 8, ["modelValue", "suffix-icon"])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ], 2),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-secondary",
              onClick: resetData
            }, _toDisplayString(_ctx.$t("action.reset")), 1),
            _createElementVNode("button", {
              class: "btn btn-sm btn-primary",
              onClick: submit,
              disabled: isLoading.value
            }, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.waiting")) + " ", 1),
                    _hoisted_33
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.saveChanges")), 1)
                  ], 64))
            ], 8, _hoisted_31)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("tip.twoFA")), 1)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("tip.authenticator")), 1),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_el_switch, {
                  "model-value": authenticatorEnabled.value,
                  onChange: onAuthenticatorEnabledChanged,
                  size: "large",
                  "inline-prompt": "",
                  "active-text": _ctx.$t('status.enabled'),
                  "inactive-text": _ctx.$t('status.disabled')
                }, null, 8, ["model-value", "active-text", "inactive-text"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t("fields.email")), 1),
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_el_switch, {
                  "model-value": emailEnabled.value,
                  onChange: onEmailEnabledChanged,
                  size: "large",
                  "inline-prompt": "",
                  "active-text": _ctx.$t('status.enabled'),
                  "inactive-text": _ctx.$t('status.disabled')
                }, null, 8, ["model-value", "active-text", "inactive-text"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createVNode(PasswordSetting)
    ]),
    _createVNode(UnifiedTwoFaVerificationModal, {
      ref_key: "twoFaModalRef",
      ref: twoFaModalRef,
      onVerified: onTwoFaVerified,
      onCancel: onTwoFaCancel
    }, null, 512)
  ], 64))
}
}

})